import { merge } from "@pdfking/rfunc"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import { defineComponent } from "vue"
import user from "../state/user"

export default defineComponent({
  computed: merge(proxy(user, ["name"]), {
    translations: () => make_translations("actions"),
  }),
  props: [] as const,
  render() {
    return <span>{this.name || this.translations.actions.GUEST}</span>
  },
})
